import FoldableGroupList from './FoldableGroupList';
import FoldableGroupListContainer from './FoldableGroupList.container';
export default FoldableGroupListContainer(FoldableGroupList);
